module.exports = __webpack_public_path__ + "img/technology-2.5cf3b407.png";